import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

export const INTEGRATION_TABS = [
  { id: 'facebook', label: 'Facebook', path: '/integrations/facebook' },
  { id: 'whatsapp', label: 'WhatsApp', path: '/integrations/whatsapp' },
  { id: 'magicbricks', label: 'MagicBricks', path: '/integrations/magicbricks' },
  { id: '99acres', label: '99acres', path: '/integrations/99acres' },
  { id: 'housing', label: 'Housing.com', path: '/integrations/housing' },
  { id: 'google_ads', label: 'Google Ads', path: '/integrations/google-ads' },
  { id: 'mcp', label: 'MCP Credentials', path: '/integrations/mcp' },
  { id: 'custom-webhooks', label: 'Custom Webhooks', path: '/integrations/custom-webhooks' },
  { id: 'whatsapp-settings', label: 'WhatsApp Settings', path: '/integrations/whatsapp-settings' },
];

const TAB_INK = '#10131A';
const TAB_MUTED = '#4B5264';
const TAB_ACCENT = '#5849EA';
const TAB_LINE = '#E6E8EE';

const getActiveTabIndex = (pathname) => {
  if (pathname.startsWith('/integrations/custom-webhooks')) {
    return INTEGRATION_TABS.findIndex((tab) => tab.id === 'custom-webhooks');
  }
  if (pathname.startsWith('/integrations/facebook')) {
    return INTEGRATION_TABS.findIndex((tab) => tab.id === 'facebook');
  }
  if (pathname.startsWith('/integrations/mcp')) {
    return INTEGRATION_TABS.findIndex((tab) => tab.id === 'mcp');
  }
  const idx = INTEGRATION_TABS.findIndex(
    (tab) => pathname === tab.path || pathname.startsWith(`${tab.path}/`),
  );
  return idx >= 0 ? idx : 0;
};

const IntegrationsTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeIndex = getActiveTabIndex(location.pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        borderBottom: `1px solid ${TAB_LINE}`,
        mb: 4,
        overflowX: 'auto',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': { height: 6 },
        '&::-webkit-scrollbar-thumb': { bgcolor: TAB_LINE, borderRadius: 3 },
      }}
    >
      {INTEGRATION_TABS.map((tab, index) => {
        const active = activeIndex === index;
        return (
          <Box
            key={tab.id}
            role="tab"
            aria-selected={active}
            tabIndex={0}
            onClick={() => navigate(tab.path)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate(tab.path);
              }
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 1.75,
              py: 1.375,
              fontSize: '13.5px',
              fontWeight: active ? 600 : 500,
              color: active ? TAB_INK : TAB_MUTED,
              borderBottom: '2px solid',
              borderColor: active ? TAB_ACCENT : 'transparent',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              mb: '-1px',
              flexShrink: 0,
              transition: 'color 0.15s ease, border-color 0.15s ease',
              '&:hover': { color: TAB_INK },
            }}
          >
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default IntegrationsTabs;
